import { Client } from 'typesense'

export const getServerClient = () => {
  const apiKey = process.env.NEXT_PUBLIC_TYPESENSE_SEARCH_API_KEY
  const nodeHost = process.env.NEXT_PUBLIC_TYPESENSE_NODE_HOST

  if (!!apiKey && !!nodeHost) {
    const client = new Client({
      nodes: [{ port: 443, protocol: 'https', host: nodeHost as never }],
      apiKey,
    })

    return client
  }

  return undefined
}
